module.exports = "/_next/static/images/salary-on-demand-67435e954a60045c4a725a0269bc6178.png";